//# sourceMappingURL=content_library.mjs.map
/// <reference types="./content_library.d.mts" />
import * as $c_cl from "../../../../altar/altar/content_library.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $checkbox from "../../../../ds/ds/components/checkbox.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $utils from "../../../../ds/ds/utils.mjs";
import * as $dict from "../../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $content_library from "../../../data/content_library.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $store from "../../../data/store.mjs";
import { toList, prepend as listPrepend } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";
import * as $ic_common from "../../../view/content_library/ingestion_control/common.mjs";
import * as $s from "../../../view/content_library/styles.mjs";

const empty_text = "Nothing is uploaded in the contant library, go to the app and upload files.";

function empty_cell() {
  return $s.empty_cell($s.empty_text_content($h.text(empty_text)));
}

function content_library_table_headers() {
  return $table.headers(
    toList([
      (() => {
        let _pipe = $table.header("");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Format");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Name");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Status");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Preview");
        return $table.fit(_pipe);
      })(),
    ]),
  );
}

function view_table_body() {
  return $redraw.compose(
    $c_cl.source_verification_label(),
    (view_source_verification_label) => {
      return $redraw.component_(
        "IngestionControl(TableBody)",
        (render) => {
          let store = $store.use_state();
          let dispatch = $store.use_dispatch();
          let dispatch$1 = (m) => {
            return dispatch(new $msg.ContentLibrary(m));
          };
          let _pipe = $table.body(
            $list.map(
              (() => {
                let _pipe = store.content_library;
                return $content_library.filtered_non_qna_sources(_pipe);
              })(),
              (source) => {
                let _block;
                let _pipe = store.ingestion_control_sources_visibility;
                let _pipe$1 = $dict.get(_pipe, source.id);
                _block = $result.unwrap(_pipe$1, false);
                let visible = _block;
                return $table.row(
                  toList([
                    (() => {
                      let _pipe$2 = $table.cell(
                        $checkbox.checkbox(
                          $checkbox.checked(
                            $content_library.is_selected(
                              store.content_library,
                              source.id,
                            ),
                          ),
                          false,
                          (checked) => {
                            let _pipe$2 = new $msg.UserSelectedSource(
                              source.id,
                              checked,
                            );
                            dispatch$1(_pipe$2);
                            return undefined;
                          },
                        ),
                      );
                      return $table.stop_cell_propagation(_pipe$2);
                    })(),
                    $table.cell(
                      $common.small_icon(
                        $utils.select_icon(
                          source.display.mime_type,
                          source.kind,
                        ),
                      ),
                    ),
                    $table.cell($h.text(source.display.name)),
                    (() => {
                      let _pipe$2 = $table.cell(
                        view_source_verification_label(new $c_cl.Props(source)),
                      );
                      return $table.stop_cell_propagation(_pipe$2);
                    })(),
                    $table.cell(
                      $l.row(
                        toList([$l.gap(8)]),
                        toList([]),
                        toList([
                          $button.primary(
                            toList([
                              $e.on_click(
                                (_) => {
                                  dispatch$1(
                                    new $msg.UserClickedOnSourceInspect(
                                      source.id,
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                            toList([$h.text("Inspect")]),
                          ),
                          $button.primary(
                            toList([
                              $e.on_click(
                                (_) => {
                                  dispatch$1(
                                    new $msg.UserClickedOnSourcePreview(
                                      source.id,
                                    ),
                                  );
                                  return undefined;
                                },
                              ),
                            ]),
                            toList([$h.text("Preview")]),
                          ),
                        ]),
                      ),
                    ),
                    $table.cell(
                      (() => {
                        if (visible) {
                          return $ic_common.preview_source(
                            store,
                            source.id,
                            new $option.Some(10),
                          );
                        } else {
                          return $h.none();
                        }
                      })(),
                    ),
                  ]),
                );
              },
            ),
          );
          return render(_pipe);
        },
      );
    },
  );
}

function view_empty_table() {
  return $redraw.component_(
    "IngestionControl(LoadingTable)",
    (render) => {
      let _pipe = $table.body(
        toList([
          (() => {
            let _pipe = $table.row(
              toList([
                (() => {
                  let _pipe = $table.cell(empty_cell());
                  return $table.span(_pipe, 7);
                })(),
              ]),
            );
            return $table.hover(_pipe, false);
          })(),
        ]),
      );
      return render(_pipe);
    },
  );
}

function view_loading_table() {
  return $redraw.component_(
    "IngestionControl(LoadingTable)",
    (render) => {
      let _pipe = $table.row(
        listPrepend(
          $table.cell($h.none()),
          (() => {
            let _pipe = $table.cell($skeleton.skeleton(100, 25));
            return $list.repeat(_pipe, 4);
          })(),
        ),
      );
      let _pipe$1 = $list.repeat(_pipe, 4);
      let _pipe$2 = $table.body(_pipe$1);
      return render(_pipe$2);
    },
  );
}

export function view() {
  return $redraw.compose(
    view_loading_table(),
    (view_loading_table) => {
      return $redraw.compose(
        view_empty_table(),
        (view_empty_table) => {
          return $redraw.compose(
            view_table_body(),
            (view_table_body) => {
              return $redraw.component_(
                "IngestionControl(ContentLibrary)",
                (_) => {
                  let store = $store.use_state();
                  let is_empty = $list.is_empty(
                    store.content_library.non_qna_sources.all,
                  );
                  let _block;
                  let $ = store.loading.content_library;
                  if ($) {
                    _block = view_loading_table;
                  } else if (is_empty) {
                    _block = view_empty_table;
                  } else {
                    _block = view_table_body;
                  }
                  let body = _block;
                  return body(
                    (children) => {
                      return $table.table(
                        toList([]),
                        toList([content_library_table_headers(), children]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
